<template>
  <div class="box">
    <div class="l">{{ info.key }}</div>
    <div class="r" :class="info.color">{{ info.val!='-'?(JSON.parse(info.val).value==1?'开':'关'):'-' }}</div>
    <div class="after1"></div>
    <div class="after2"></div>
    <div class="after3"></div>
    <div class="after4"></div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data() {
    return {
      val
    };
  },
  methods: {},
  watch: {
    info: function (newval, oldval) {
      if (newval !== oldval) {

      }
    },
  }
};
</script>

<style lang="scss" scoped>
$height: 0.15rem;
.box {
  position: relative;
  width: 100%;
  height: $height;
  line-height: $height;
  font-size: 0.05rem;
  color: #151a86;
  font-weight:500;
}
.l { height: $height;
  display: inline;
  position: relative;
  float: left;
  font-size: 0.05rem;
}
.l::after {
  content: " ";
  display: block;
  position: absolute;
  left: 110%;
  top:  0.06rem;
  width: 0.1025rem;
  height: 0.04rem;
  background: url(../img/tafter.png);
  background-size: 100% 100%;
}
.r { height: $height;
  font-weight: 700;
  font-size: 0.07rem;
  width: 25%;
  float: right;
  text-align: right;
}
.red {
  color: #fb7a8e;
}
.green {
  color: #37baca
}
.after1 {
  position: absolute;
  height: .01rem;
  left:0rem;
  width:.03rem;
  bottom:0rem;
  background: #0f69ca;
}
.after2 {
  position: absolute;
  height: .005rem;
  left:.04rem;
  width: .06rem;
  bottom:0rem;
  background: #0f69ca;
}
.after3 {
  position: absolute;
  height: 1px;
  left:.12rem;
  right: 0;
  bottom:0rem;
  background: rgba($color: #0f69ca, $alpha: 0.12);
}
.after4 {
  position: absolute;
  height: .005rem;
  width:.05rem;
  right: 0;
  bottom:0rem;
  background: #0f69ca;
}
</style>



// WEBPACK FOOTER //
// src/components/webgl/ui/valstatus/index.vue